import { Button } from '@monorepo/shared/componentsV2/Button';
import { BaseModal } from '@monorepo/shared/componentsV2/modals/BaseModal';
import { USAGE_TRACKING_PREFIX } from '@monorepo/shared/constants/usageTracking';
import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import { useFormTemplateContext } from '../../EditFormTemplatePage/FormTemplateContext';
import { UpdateFormTemplateFieldGroupFormValues } from '../types';
import { EditSectionForm } from './EditSectionForm';

export type EditSectionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  sectionFormValues: UpdateFormTemplateFieldGroupFormValues;
};

export function EditSectionModal({
  isOpen,
  onClose,
  sectionFormValues,
}: EditSectionModalProps) {
  const {
    formTemplateHelpers: { updateGroupInfo },
  } = useFormTemplateContext();

  const handleNameSubmit = useCallback(
    (groupFormValues: UpdateFormTemplateFieldGroupFormValues) => {
      updateGroupInfo(groupFormValues);
      onClose();
    },
    [updateGroupInfo, onClose],
  );

  return (
    <Form
      onSubmit={handleNameSubmit}
      initialValues={sectionFormValues}
      subscription={{ invalid: true, pristine: true }}
    >
      {({ handleSubmit, pristine, invalid }) => (
        <BaseModal
          id={`${USAGE_TRACKING_PREFIX}-edit-form-template-section-modal`}
          title="Edit section"
          open={isOpen}
          onClose={onClose}
          maxWidth="sm"
          buttons={
            <>
              <Button color="primary" onClick={onClose} type="button">
                Cancel
              </Button>
              <Button
                color="primary"
                disabled={pristine || invalid}
                onClick={handleSubmit}
                type="submit"
                variant="contained"
              >
                Apply
              </Button>
            </>
          }
        >
          <EditSectionForm currentName={sectionFormValues.name} isEditing />
        </BaseModal>
      )}
    </Form>
  );
}
